import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

import {StyledInput, StyledLabel} from './styles';

@inject('store')
@observer
class Input extends Component {
  render() {
    const {name, label, value, onChange, disabled, isDesktop, testId, onFocus} = this.props;

    return (
      <>
        <StyledLabel isDesktop={isDesktop}>{label}</StyledLabel>
        <StyledInput
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          isDesktop={isDesktop}
          data-testid={testId}
          onFocus={onFocus}
        />
      </>
    );
  }
}

export default Input;
